import axiosInstance from 'core/network/axiosInstance'

export interface GrievanceApi {
  id: string
  order_id: string
  raised_by: string
  buyer_name?: string
  buyer_type?: string
  status: string
  reason?: string
  assigned_am_id?: string
  assigned_am_name?: string
  description?: string
  affected_units?: number
  evidence_urls?: string[]
  ordered_units?: number
  received_units?: number
  resolved_at?: string
  resolved_by?: string
  resolution_notes?: string
  created_at: string
  updated_at: string
}

export interface GrievanceListApiResponse {
  skip: number
  limit: number
  total: number
  data: GrievanceApi[]
}

export interface GetGrievancesApiParams {
  skip: number
  limit: number
  status?: string
  search?: string
  order_id?: string
  assigned_am_id?: string
  raised_by?: string
}

export interface AssignGrievanceApiRequest {
  assigned_am_id: string
}

export interface ResolveGrievanceApiRequest {
  resolution_notes: string
}

export interface FarmerEntryApi {
  farmer_name: string
  phone_number: string
  units: number
  price_per_unit: number
  total_value: number
}

export interface VLCCEntryApi {
  vlcc_name: string
  units_received: number
  vlcc_to_farmers: FarmerEntryApi[]
}

export interface FactoryDispatchApi {
  dispatched_qty: number
  gate_received_qty: number
  shortage_deficit: number
  affected_units?: number
  reported_issue?: string
}

export interface AuditLedgerApiResponse {
  grievance_id: string
  order_id: string
  total_farmers_count: number
  factory_to_fpo: FactoryDispatchApi
  fpo_to_farmers: FarmerEntryApi[]
  fpo_to_vlcc: VLCCEntryApi[]
}

class GrievanceApiDatasource {
  async getGrievances(params: GetGrievancesApiParams): Promise<GrievanceListApiResponse> {
    const { data } = await axiosInstance.get<GrievanceListApiResponse>('/api/v1/grievances', { params })
    return data
  }

  async getGrievanceById(id: string): Promise<GrievanceApi> {
    const { data } = await axiosInstance.get<GrievanceApi>(`/api/v1/grievances/${id}`)
    return data
  }

  async getAuditLedger(id: string): Promise<AuditLedgerApiResponse> {
    const { data } = await axiosInstance.get<AuditLedgerApiResponse>(`/api/v1/grievances/${id}/audit-ledger`)
    return data
  }

  async assignAm(id: string, payload: AssignGrievanceApiRequest): Promise<GrievanceApi> {
    const { data } = await axiosInstance.patch<GrievanceApi>(`/api/v1/grievances/${id}/assign`, payload)
    return data
  }

  async resolveGrievance(id: string, payload: ResolveGrievanceApiRequest): Promise<GrievanceApi> {
    const { data } = await axiosInstance.patch<GrievanceApi>(`/api/v1/grievances/${id}/resolve`, payload)
    return data
  }
}

export const grievanceApiDatasource = new GrievanceApiDatasource()
